import Vue from "vue";
import VueRouter from "vue-router";
import goTo from "vuetify/es5/services/goto";

import store from "@/store";
import Home from "@/views/Home.vue";
import Callback from "@/views/Callback.vue";
import VersionUpdate from "@/views/VersionUpdate.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "404",
    component: () => import("@/views/404.vue"),
    meta: {
      secured: false,
      saveToLast: false,
      layout: "centered-layout",
      title: "Page Not Found",
    },
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/403.vue"),
    meta: {
      secured: false,
      saveToLast: false,
      layout: "centered-layout",
      title: "UnAuthorized Page",
    },
  },
  {
    path: "/callback",
    name: "Callback",
    component: Callback,
    meta: {
      secured: false,
      saveToLast: false,
      layout: "centered-layout",
      title: "Authenticating User",
    },
  },

  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      secured: false,
      saveToLast: false,
      layout: "centered-layout",
      title: "Parked(TM) Admins",
    },
  },

  {
    path: "/pwa-update",
    name: "VersionUpdate",
    components: {
      default: VersionUpdate,
    },
    meta: {
      secured: false,
      layout: "centered-layout",
      title: "Version Update.",
    },
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Dashboard",
    },
  },

  {
    path: "/leads",
    name: "Leads",
    component: () => import("@/views/Leads.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Leads",
    },
  },

  {
    path: "/notifications",
    name: "Notifications",
    component: () => import("@/views/Notifications.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Notifications",
    },
  },

  {
    path: "/checkins",
    name: "Checkins",
    component: () => import("@/views/Checkins.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Vehicle Check-Ins",
    },
  },

  {
    path: "/service-checkins",
    name: "Service Checkins",
    component: () => import("@/views/ServiceCheckins.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Service Check-Ins",
    },
  },

  {
    path: "/condition-checkins",
    name: "Condition Checkins",
    component: () => import("@/views/ConditionCheckins.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Condition Check-Ins",
    },
  },
  {
    path: "/condition-checkins/:id",
    name: "ConditionCheckin",
    component: () => import("@/views/ConditionCheckin.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Condition Check-In",
    },
  },
  {
    path: "/condition-checkins/:id/insights",
    name: "ConditionCheckinInsights",
    component: () => import("@/views/ConditionCheckinInsights.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Condition Check-In Insights",
    },
  },
  {
    path: "/proof-of-address-checkins",
    name: "Proof of Address Checkins",
    component: () => import("@/views/ProofOfAddressCheckins.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Proof of Address Check-Ins",
    },
  },
  {
    path: "/proof-of-address-checkins/:id",
    name: "ProofOfAddressCheckin",
    component: () => import("@/views/ProofOfAddressCheckin.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Proof Of AddressCheck-In",
    },
  },
  {
    path: "/property-checkins",
    name: "PropertyCheckins",
    component: () => import("@/views/PropertyCheckins.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Property Check-Ins",
    },
  },

  {
    path: "/property-checkins/:id",
    name: "PropertyCheckin",
    component: () => import("@/views/PropertyCheckin.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "centered-layout",
      title: "Property Check-In",
    },
  },
  {
    path: "/survey-responses",
    name: "SurveyResponses",
    component: () => import("@/views/Surveys.vue"),
    meta: {
      requiresAuth: true,
      title: "Survey Responses",
    },
  },
  {
    path: "/survey-responses/:id",
    name: "SurveyResponseDetail",
    component: () => import("@/views/SurveyResponse.vue"),
    meta: {
      requiresAuth: true,
      title: "Survey Response Detail",
    },
  },
  {
    path: "/surveys",
    name: "Surveys",
    component: () => import("@/views/Surveys.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Surveys",
    },
  },
  {
    path: "/surveys/:id",
    name: "Survey",
    component: () => import("@/views/Survey.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "centered-layout",
      title: "Survey",
    },
  },
  {
    path: "/survey-templates/:id",
    name: "SurveyTemplate",
    component: () => import("@/views/SurveyTemplate.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Survey Template",
    },
  },
  {
    path: "/survey-templates/v2/:id",
    name: "SurveyTemplateV2",
    component: () => import("@/views/SurveyTemplateNew.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Survey Template",
    },
  },
  {
    path: "/survey-groups/:id",
    name: "SurveyGroup",
    component: () => import("@/views/SurveyGroup.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Survey Group",
    },
  },

  {
    path: "/policy-checkins",
    name: "PolicyCheckins",
    component: () => import("@/views/PolicyCheckins.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Policy Check-Ins",
    },
  },

  {
    path: "/connected-policy-checkins",
    name: "ConnectedPolicyCheckins",
    component: () => import("@/views/ConnectedPolicyCheckins.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Canopy Policy Check-Ins",
    },
  },

  {
    path: "/policy-checkins/:id",
    name: "PolicyCheckin",
    component: () => import("@/views/PolicyCheckin.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Policy Check-Ins",
    },
  },

  {
    path: "/connected-policy-checkin/:id",
    name: "ConnectedPolicyCheckin",
    component: () => import("@/views/ConnectedPolicyCheckin.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Canopy Policy Check-In",
    },
  },

  {
    path: "/rewards",
    name: "Rewards",
    component: () => import("@/views/Rewards.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Rewards",
    },
  },

  {
    path: "/payouts",
    name: "Payouts",
    component: () => import("@/views/Payouts.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Payouts",
    },
  },

  {
    path: "/campaigns/",
    name: "MarketingCampaigns",
    component: () => import("@/views/MarketingCampaigns.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Marketing Campaigns",
    },
  },

  {
    path: "/insurance/",
    name: "InsuranceCompanies",
    component: () => import("@/views/InsuranceCompanies.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Insurance Companies",
    },
  },

  {
    path: "/insurance/:id",
    name: "InsuranceCompany",
    component: () => import("@/views/InsuranceCompany.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Insurance Company",
    },
  },

  {
    path: "/data-buyers/",
    name: "DataBuyers",
    component: () => import("@/views/DataBuyers.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Data Buyers",
    },
  },

  {
    path: "/data-buyer/:id",
    name: "DataBuyer",
    component: () => import("@/views/DataBuyer.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Data Buyer",
    },
  },

  {
    path: "/data-buyer/:databuyerId/campaign/:id",
    name: "DataBuyers",
    component: () => import("@/views/DataBuyerRewardCampaign.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Campaign",
    },
  },

  {
    path: "/customer/:id",
    name: "Customer",
    component: () => import("@/views/Customer.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Customer",
    },
  },

  {
    path: "/vehicle/:id",
    name: "Vehicle",
    component: () => import("@/views/Vehicle.vue"),
    props: (route) => ({ id: route.params.id }),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "inner-page-layout",
      title: "Vehicle",
    },
  },

  {
    path: "/reports/",
    name: "Reports",
    component: () => import("@/views/Reports.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Reports",
    },
  },

  {
    path: "/integrations-tester/",
    name: "IntegrationsTester",
    component: () => import("@/views/IntegrationsTester.vue"),
    meta: {
      secured: true,
      saveToLast: false,
      layout: "default-layout",
      title: "Integrations Tester",
    },
  },

  {
    path: "/check-in-builder/",
    name: "CheckInBuilder",
    component: () => import("@/views/CheckInBuilder.vue"),
    meta: {
      secured: true,
      saveToLast: false,
      layout: "default-layout",
      title: "Check-in Builder",
    },
  },
  {
    path: "/document-checkin/configs",
    name: "DocumentCheckinConfigList",
    component: () => import("@/views/document-checkin/ConfigurationsList.vue"),
  },
  {
    path: "/document-checkin/configs/create",
    name: "DocumentCheckinConfigCreate",
    component: () => import("@/views/document-checkin/ConfigurationEdit.vue"),
  },
  {
    path: "/document-checkin/configs/:id/edit",
    name: "DocumentCheckinConfigEdit",
    component: () => import("@/views/document-checkin/ConfigurationEdit.vue"),
  },
  {
    path: "/document-checkins",
    name: "DocumentCheckinsList",
    component: () => import("@/views/document-checkin/DocumentCheckinsList.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Document Check-Ins",
    },
  },
  {
    path: "/document-checkins/:id",
    name: "DocumentCheckinDetail",
    component: () => import("@/views/document-checkin/DocumentCheckinDetail.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Document Check-In Details",
    },
  },
  {
    path: '/extended-warranty-flows',
    name: 'ExtendedWarrantyFlowsList',
    component: () => import('@/views/extended-warranty/ExtendedWarrantyFlowsList.vue'),
    meta: {
      title: 'Extended Warranty Flows',
      requiresAuth: true,
      requiresAdmin: true, // Adjust based on your auth requirements
    },
  },
  {
    path: '/extended-warranty-flows/:id',
    name: 'ExtendedWarrantyFlowDetail',
    component: () => import('@/views/extended-warranty/ExtendedWarrantyFlowDetail.vue'),
    meta: {
      title: 'Extended Warranty Flow Details',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/refinancing-flows',
    name: 'RefinancingFlowsList',
    component: () => import('@/views/refinancing/RefinancingFlowsList.vue'),
    meta: {
      title: 'Refinancing Flows',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/refinancing-flows/:id',
    name: 'RefinancingFlowDetail',
    component: () => import('@/views/refinancing/RefinancingFlowDetail.vue'),
    meta: {
      title: 'Refinancing Flow Details',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
});

router.beforeResolve((to, from, next) => {
  const title = to.meta && to.meta.title ? to.meta.title : to.name;
  document.title = title;

  //console.log("router.beforeResolve:", to);

  if (to.meta && to.meta.secured) {
    const authenticated = store.getters["auth/authenticated"];
    const authorized = store.getters["auth/authorized"];
    if (authenticated && authorized) {
      next();
    } else {
      if (to.meta && to.meta.saveToLast) {
        const saved_route_data = {
          path: to.path,
          params: to.params,
          query: to.query,
        };
        localStorage.setItem("route_to", JSON.stringify(saved_route_data));
      }

      next({
        name: "403",
      });
    }
  } else {
    next();
  }
});

export default router;
